module.exports = __webpack_public_path__ + "img/testpaper_down_normal.e8707cd2.svg";